import { Center, Heading, Text, VStack } from '@chakra-ui/react'
import { useAdminArticleCtas } from '@olagg/api-hooks'
import { ArticleCtaType } from '@olagg/db-types'
import { FormArticleCtaData } from '@olagg/validation-schemas/articleCta.schemas'
import { useLocation, useNavigate } from 'react-router-dom'
import { ROUTES } from '../../consts/routes'
import ArticleCtaForm from './Form'
import { toArticleCtaPayload } from './payload'

const CreateArticleCta = () => {
  const navigate = useNavigate()
  const { state } = useLocation() as { state?: { articleCta?: ArticleCtaType } }
  const { createArticleCta } = useAdminArticleCtas({ page: 1, limit: 10 })

  /**
   * Duplicar trae la fila entera menos su identidad: la `key` se vacía porque es
   * la que viaja como `cta_id` en los eventos y dos filas con la misma key serían
   * indistinguibles al medir.
   */
  const template = state?.articleCta
    ? ({ ...state.articleCta, id: undefined, uid: undefined, key: '' } as unknown as ArticleCtaType)
    : undefined

  const onSubmit = (dataForm: FormArticleCtaData) => {
    createArticleCta(toArticleCtaPayload(dataForm), () => navigate(ROUTES.ARTICLE_CTAS.all))
  }

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>{template ? 'Duplicar CTA' : 'Crear CTA'}</Heading>
        {template && (
          <Text color='gray.400' fontSize='sm' textAlign='center' maxW='600px'>
            Copiado de <b>{state?.articleCta?.key}</b>. Ponele una key nueva y cambiá lo que haga falta.
          </Text>
        )}
        <ArticleCtaForm onSubmit={onSubmit} articleCta={template} />
      </VStack>
    </Center>
  )
}

export default CreateArticleCta
